import { render } from "./StudentHomeView.vue?vue&type=template&id=2fc59495&scoped=true"
import script from "./StudentHomeView.vue?vue&type=script&lang=js"
export * from "./StudentHomeView.vue?vue&type=script&lang=js"

import "./StudentHomeView.vue?vue&type=style&index=0&id=2fc59495&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc59495"]])

export default __exports__